import { authService } from '@/services/auth';
import { normalizeEmail, parseNameFromEmail } from '@/config/authAllowlist';
import type { User } from '@/types';

const OPERATOR_SITE = '3rd, 9th & 10th floors';
const NOVICE_SITE = 'First floor';

function initials(firstName: string, lastName: string): string {
  const a = firstName.charAt(0)?.toUpperCase() ?? '';
  const b = lastName.charAt(0)?.toUpperCase() ?? '';
  return `${a}${b}` || 'U';
}

/** Increment sign-in count and build session user for a successful login. */
export function buildUserForLogin(email: string): User {
  const normalized = normalizeEmail(email);
  const signInCount = authService.incrementSignInCount(normalized);
  const role = authService.resolveRoleFromSignInCount(signInCount);
  const { firstName, lastName } = parseNameFromEmail(normalized);

  return {
    id: normalized,
    email: normalized,
    firstName,
    lastName,
    name: `${firstName} ${lastName}`,
    role,
    site: role === 'operator' ? OPERATOR_SITE : NOVICE_SITE,
    initials: initials(firstName, lastName),
  };
}
